import { visitTypeLabels } from "~/services/scheduling/constants";
import type { VisitType } from "~/services/scheduling/types";

type BookingConfirmation = {
  visitType: VisitType;
  date: string;
  time: string;
  providerName: string;
  isNewAccount: boolean;
};

export const getBookingConfirmedMessage = ({
  visitType,
  date,
  time,
  providerName,
  isNewAccount,
}: BookingConfirmation) => {
  const label = visitTypeLabels[visitType].toLowerCase();
  const article = /^[aeiou]/.test(label) ? "An" : "A";
  const verificationEmail = isNewAccount
    ? " and an account verification email"
    : "";

  return {
    title: `${label.charAt(0).toUpperCase()}${label.slice(1)} booked`,
    description: `${article} ${label} on ${date} at ${time} (ET) with ${providerName} has been booked. The patient will receive an email & text visit confirmation${verificationEmail} shortly.`,
  };
};
